import React, {useEffect, useState} from 'react';
import {AtInput} from 'taro-ui';
import {LabelWidget} from "../../index";
const TInputWidget = (props:any) => {
  const {label, value:wValue, inputType, isRequired, regex,
    fontSize,
    color,
    fontStyle,
    inputFontSize,
    inputColor,
    inputFontStyle,
    bgColor,
    borderColor,
    readonly,
    labelPosition,
    labelAlignment,
    borderBottomColor,
    borderBottomWidth,
    labelWidth,
    placeholder,
    placeholderAlignment,
    maxLength,
    currentItem,
    onValueBlur,
    onValueFocus,
    onValueChange
  } = props;
  const [value, setValue] = useState(wValue);
  const [status, setStatus] = useState(false);
  const reg_phone = /^1[3-9]\d{9}$/;
  const reg_number = /^-?\d+$/;
  const reg_email = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  const reg_idcard = /^[1-9]\d{5}\d{4}((0[1-9])|(10|11|12))(([0|1|2][0-9])|10|20|30|31)\d{3}(\d|[Xx])$/;
  const handleChange = (value:any)=> {
    setValue(value);
    if(value){
      let pattern ;
      if(regex){
        pattern = new RegExp(`${regex}`);
      }else if(inputType === 'phone'){
        pattern = reg_phone;
      }else if(inputType === 'number'){
        pattern = reg_number;
      }else if(inputType === 'email'){
        pattern = reg_email;
      }else if(inputType === 'idcard'){
        pattern = reg_idcard;
      }
      if(pattern){
        setStatus(!pattern.test(value));
      }
    }
    onValueChange(value);
  };
  useEffect(()=>{
    //let countValue = currentItem?.[widgetName]??wValue;
    let countValue = wValue;
    if(wValue&&maxLength&&wValue.length > maxLength){
      setValue(countValue.substring(0, maxLength));
    }else{
      setValue(countValue);
    }
  }, [wValue, currentItem]);
  return (
    <LabelWidget
      label={label}
      fontSize={fontSize}
      color={color}
      fontStyle={fontStyle}
      inputFontSize={inputFontSize}
      inputColor={inputColor}
      inputFontStyle={inputFontStyle}
      bgColor={bgColor}
      borderColor={borderColor}
      labelAlignment={labelAlignment}
      labelPosition={labelPosition}
      required={isRequired}
      borderBottomColor={borderBottomColor}
      borderBottomWidth={borderBottomWidth}
      labelWidth={labelWidth}
      placeholderAlignment={placeholderAlignment}
    >
      <AtInput
        editable={!readonly}
        error={status}
        name='value'
        type={inputType}
        placeholder={placeholder}
        value={value}
        onChange={handleChange}
        onFocus={onValueFocus}
        onBlur={onValueBlur}
      />
    </LabelWidget>
  );
};

export default TInputWidget;
